import { useEffect, useCallback } from "react";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { env } from "../../../../res/config/env";

const TheProducer = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();

    // Use useCallback to memoize the produceToken function
    const produceToken = useCallback(async () => {
        if (!executeRecaptcha) return;
        
        console.log("producing token");
        const token = await executeRecaptcha();
        console.log("got token");

        // Sending the token to the parent window
        window.parent.postMessage({ type: "mobile_captcha_producer", token }, "*");
    }, [executeRecaptcha]); // Only re-run if executeRecaptcha changes

    useEffect(() => {
        // Call produceToken when executeRecaptcha is available
        void produceToken();
    }, [produceToken]); // Re-run if produceToken changes (which it won't due to useCallback)

    return <div>Verifying...</div>;
}

const MobileCaptchaProducer = () => {
    return (
        <GoogleReCaptchaProvider reCaptchaKey={env.CAPTCHA_KEY}>
            <TheProducer />
        </GoogleReCaptchaProvider>
    )
}

export default MobileCaptchaProducer;
